import React, { Component } from 'react'
import '../styles/OrganizationFinancingTrack.css'
import OrgFooter from '../widgets/OrgFooter'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import DropdownWidget from '../widgets/DropdownWidget'
import TickBoxWidget from '../widgets/TickBoxWidget'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'

class OrganizationFinancingTrack extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			dateToday: sessionStorage.getItem("date-today"),
			arboId: sessionStorage.getItem("arbo-id"),
			scrollable: false,
			fsItemObj: {},
			fsKeyTracer: 0,
			fsListItems: [],
			leItemObj: {},
			leKeyTracer: 0,
			leListItems: [],
			lfItemObj: {},
			lfKeyTracer: 0,
			lfListItems: [],
			financialSystem: {},
			financingStrategy: {},
			deleteFinancialSystem: {},
			deleteFinancingStrategy: {},
			shouldDisplayValues: props.displayValues,
			isViewDetails: props.isViewDetails,
			paidCBU: "0",
			withSavings: "0",
			savings: "0.00",
			cbu: "0.00"
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.fmEventHandler = this.fmEventHandler.bind(this)
		this.fsEventHandler = this.fsEventHandler.bind(this)
		this.setMechanismTracking = this.setMechanismTracking.bind(this)
		this.setFinancingStrategy = this.setFinancingStrategy.bind(this)
		this.getFundSources = this.getFundSources.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const financingStrategy = []
		const addFinancingStrategy = []
		Object.values(this.state.financingStrategy).forEach((v) => {
			if(v.id != null) {
				financingStrategy.push(v)
			}
			else {
				addFinancingStrategy.push(v)
			}
		})
		const deleteFinancingStrategy = []
		Object.values(this.state.deleteFinancingStrategy).forEach((v) => {
			deleteFinancingStrategy.push(v)
		})
		const financialSystem = []
		const addFinancialSystem = []
		Object.values(this.state.financialSystem).forEach((v) => {
			if(v.id != null) {
				financialSystem.push(v)
			}
			else {
				addFinancialSystem.push(v)
			}
		})
		const deleteFinancialSystem = []
		Object.values(this.state.deleteFinancialSystem).forEach((v) => {
			deleteFinancialSystem.push(v)
		})
		if(financingStrategy.length > 0 || financialSystem.length > 0 ||
			deleteFinancingStrategy.length > 0 || deleteFinancialSystem.length > 0) {
			var data = {
				financingStrategy: financingStrategy,
				financialSystem: financialSystem,
				add: {
					financingStrategy: addFinancingStrategy,
					financialSystem: addFinancialSystem,
				},
				delete: {
					financingStrategy: deleteFinancingStrategy,
					financialSystem: deleteFinancialSystem,
				}
			}
		}
		else {
			data = {
				financingStrategy: addFinancingStrategy,
				financialSystem: addFinancialSystem
			}
		}
		if(data.add == null && data.delete == null && financingStrategy.length < 1 &&
			financialSystem.length < 1) {
			const apiReq = APIOrganizationRequest.addFinanceTracking(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					financialSystem: {},
					financingStrategy: {}
				})
			})
		}
		else {
			const apiReq = APIOrganizationRequest.editFinanceTracking(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					financialSystem: {},
					financingStrategy: {}
				})
			})
		}
	}

	componentDidMount() {
		this.setState({showActivityIndicator: true})
		const obi = APIOrganizationRequest.getFarmerOrgById(this.state.accessToken, this.state.arboId)
		obi.then((response) => {
			this.setState({
				orgName: response.results.name,
				partnershipType: response.results.category,
				province: response.results.province,
				city: response.results.city,
				arcName: response.results.arc_name,
				partnershipDate: response.results.partnership_date
			})
			const cm = APIOrganizationRequest.getFinanceTrackingById(this.state.accessToken, this.state.arboId)
			cm.then((response) => {
				this.setMechanismTracking(response.results.financialSystem)
				this.setFinancingStrategy(response.results.financingStrategy)
				this.setScrollable()
			})
		})
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	setMechanismTracking(financialSystem) {
		const loans = []
		if(financialSystem != null) {
			for(const v of financialSystem) {
				const lfKey = "lf-" + this.state.lfKeyTracer
				this.state.lfItemObj[lfKey] = <LoanFinancialMechanism data={v} handler={this.fmEventHandler}
					disabled={this.state.isViewDetails} key={lfKey} id={lfKey} />
				this.state.lfKeyTracer++
			}
			const lfKey = "lf-" + this.state.lfKeyTracer
			this.state.lfItemObj[lfKey] = <LoanFinancialMechanism handler={this.fmEventHandler}
				disabled={this.state.isViewDetails} key={lfKey} id={lfKey} />
			this.state.lfKeyTracer++
			Object.keys(this.state.lfItemObj).forEach((k => {
				loans.push(this.state.lfItemObj[k])
			}))
		}
		else {
			const lfKey = "lf-" + this.state.lfKeyTracer
			this.state.lfItemObj[lfKey] = <LoanFinancialMechanism handler={this.fmEventHandler} key={lfKey} id={lfKey} />
			this.state.lfKeyTracer++
			loans.push(this.state.lfItemObj[lfKey])
		}
		this.setState({lfListItems: loans, showActivityIndicator: false})
	}

	setFinancingStrategy(financingStrategy) {
		const loans = []
		if(financingStrategy != null) {
			for(const v of financingStrategy) {
				v["arboId"] = this.state.arboId
				const fsKey = "fs-" + this.state.fsKeyTracer
				this.state.fsItemObj[fsKey] = <FinancingStrategy data={v} handler={this.fsEventHandler}
					disabled={this.state.isViewDetails} key={fsKey} id={fsKey} />
				this.state.fsKeyTracer++
			}
			const fsKey = "fs-" + this.state.fsKeyTracer
			this.state.fsItemObj[fsKey] = <FinancingStrategy handler={this.fsEventHandler}
				disabled={this.state.isViewDetails} key={fsKey} id={fsKey} />
			this.state.fsKeyTracer++
			Object.keys(this.state.fsItemObj).forEach((k => {
				loans.push(this.state.fsItemObj[k])
			}))
		}
		else {
			const fsKey = "fs-" + this.state.fsKeyTracer
			this.state.fsItemObj[fsKey] = <FinancingStrategy handler={this.fsEventHandler}
				key={fsKey} id={fsKey} disabled={this.state.isViewDetails} />
			this.state.fsKeyTracer++
			loans.push(this.state.fsItemObj[fsKey])
		}
		this.setState({fsListItems: loans, showActivityIndicator: false})
	}

	fmEventHandler(e, compId, key, value) {
		switch(e) {
			case "mechanism":
				this.state.financialSystem[compId] = value
				break
			case "add":
				this.state.financialSystem[compId] = value
				const added = []
				const lfKey = "lf-" + this.state.lfKeyTracer
				this.state.lfItemObj[lfKey] = <LoanFinancialMechanism handler={this.fmEventHandler} key={lfKey} id={lfKey} />
				this.state.lfKeyTracer++
				this.state.lfListItems.push(this.state.lfItemObj[lfKey])
				Object.keys(this.state.lfItemObj).forEach((k => {
					added.push(this.state.lfItemObj[k])
				}))
				this.setState({lfListItems: added})
				break
			case "delete":
				this.state.deleteFinancialSystem[compId] = value
				delete this.state.lfItemObj[compId]
				const deleted = []
				Object.keys(this.state.lfItemObj).forEach((k => {
					deleted.push(this.state.lfItemObj[k])
				}))
				this.setState({lfListItems: deleted})
		}
		this.setScrollable()
	}

	fsEventHandler(e, compId, key, value) {
		switch(e) {
			case "finance":
				this.state.financingStrategy[compId] = value
				break
			case "add":
				this.state.financingStrategy[compId] = value
				const added = []
				const fsKey = "fs-" + this.state.fsKeyTracer
				this.state.fsItemObj[fsKey] = <FinancingStrategy handler={this.fsEventHandler} key={fsKey} id={fsKey} />
				this.state.fsKeyTracer++
				this.state.fsListItems.push(this.state.fsItemObj[fsKey])
				Object.keys(this.state.fsItemObj).forEach((k => {
					added.push(this.state.fsItemObj[k])
				}))
				this.setState({fsListItems: added})
				break
			case "delete":
				this.state.deleteFinancingStrategy[compId] = value
				delete this.state.fsItemObj[compId]
				const deleted = []
				Object.keys(this.state.fsItemObj).forEach((k => {
					deleted.push(this.state.fsItemObj[k])
				}))
				this.setState({fsListItems: deleted})
		}
		this.setScrollable()
	}


	getFundSources() {
		const c = JSON.parse(localStorage.getItem("fund-source"))
		if(c != null) {
			this.setState({fundSources: c})
			return
		}
		const types = APIOrganizationRequest.getAllFundSources(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.fund_source_id, name: v.name})
			}
			localStorage.setItem("fund-source", JSON.stringify(c))
			this.setState({fundSources: c})
		})
	}


	setScrollable() {
		const sa = document.getElementById('of-scroll-area')
		const ca = document.getElementById('of-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+75) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="org-finance">
			<div id="of-scroll-area"><div id="of-client-area">
				<div id="oft-cell1">
					<div id="oft-cell1-r1">
						<div id="oft-cell1-r1-i1">
							<div>Organization Name</div>
							<input type="text" value={this.state.orgName} disabled="true" />
						</div>
						<div id="oft-cell1-r1-i2">
							<div>Type</div>
							<input type="text" value={this.state.partnershipType} disabled="true" />
						</div>
					</div>
					<div id="oft-cell1-r2">
						<div id="oft-cell1-r2-i1">
							<div>Province</div>
							<input type="text" value={this.state.province} disabled="true" />
						</div>
						<div id="oft-cell1-r2-i2">
							<div>Municipality</div>
							<input type="text" value={this.state.city} disabled="true" />
						</div>
						<div id="oft-cell1-r2-i3">
							<div>Name of Agrarian Reform Community</div>
							<input type="text" value={this.state.arcName} disabled="true" />
						</div>
					</div>
				</div>
				<div id="org-tracks">
					<div>
						<div className="title-bar">FINANCING STRATEGY TRACKING</div>
						<div id="oft-cell2">
							<table className="oft-table-header">
								<col style={{width: '35%'}} />
								<col style={{width: '65%'}} />
								<tr>
									<th>Date</th>
									<th>Financial Delivery Scheme / Strategy</th>
								</tr>
							</table>
							{this.state.fsListItems}
						</div>
					</div>
					<div>
						<div className="title-bar">FINANCIAL SYSTEM / MECHANISM TRACKING</div>
						<div id="oft-cell6">
							<table className="oft-table-header">
								<col style={{width: '40%'}} />
								<col style={{width: '60%'}} />
								<tr>
									<th>Date of Release</th>
									<th>Type of Financial Mechanism</th>
								</tr>
							</table>
							{this.state.lfListItems}
						</div>
					</div>
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
					<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class LoanFinancialMechanism extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			financialMechanismLoan: {},
			name: "-- SELECT --",
			disabled: props.disabled
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const types = APIOrganizationRequest.getAllFinancialMechanisms(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.mechanism_type_id, name: v.name})
			}
			this.setState({loans: c})
		})
	}
	componentDidMount() {
		if(this.props.data != null) {
			this.state.financialMechanismLoan["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				name: this.props.data.mechanism_type,
				dateInstalled: this.props.data.date_installed,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.financialMechanismLoan)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove financial system ${this.state.name}?`
		})
	}

	render() {
		const view = <div className="loan-mechanism">
			<div>{this.state.addDeleteButton}</div>
			<table className="oft-table-data">
				<col style={{width: '40%'}} />
				<col style={{width: '60%'}} />
				<tr>
					<td><DatePicker value={this.state.dateInstalled} onChange={(value) => {
						this.state.financialMechanismLoan["date_installed"] = value
						this.props.handler("mechanism", this.state.itemId, null, this.state.financialMechanismLoan)
						this.setState({dateInstalled: value})
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}} disabled={this.state.disabled} /></td>
					<td><DropdownWidget list={this.state.loans} placeholder={this.state.name}
						cStyle={{'width': '100%'}} onItemSelected={(id, val) => {
							this.state.financialMechanismLoan["mechanism_type_id"] = id
							this.props.handler("mechanism", this.state.itemId, null, this.state.financialMechanismLoan)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.financialMechanismLoan)
					}
			}} />}
		</div>
		return(view)
	}
}

class FinancingStrategy extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			financingStrategy: {},
			name: "-- SELECT --",
			disabled: props.disabled
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const types = APIOrganizationRequest.getAllFinancialMechanisms(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.mechanism_type_id, name: v.name})
			}
			this.setState({loans: c})
		})
	}
	componentDidMount() {
		if(this.props.data != null) {
			this.state.financingStrategy["id"] = this.props.data.id
			this.state.financingStrategy["arbo_id"] = this.props.data.arboId
			this.state.financingStrategy["date_applied"] = this.props.data.date_applied
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			const tbDefault = []
			if(this.props.data.linker == 1) {
				tbDefault.push(0)
			}
			if(this.props.data.conduit == 1) {
				tbDefault.push(1)
			}
			if(this.props.data.service_provider == 1) {
				tbDefault.push(2)
			}
			this.setState({
				dateApplied: this.props.data.date_applied,
				tbDefault: tbDefault,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.financingStrategy)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove financial delivery scheme / strategy ${this.state.financingStrategy.date_applied}?`
		})
	}

	render() {
		const tbOptions = ["LINKER", "LOAN CONDUIT", "SERVICE PROVIDER"]
		const view = <div className="financing-strategy">
			<div>{this.state.addDeleteButton}</div>
			<table className="oft-table-data">
				<col style={{width: '35%'}} />
				<col style={{width: '65%'}} />
				<tr>
					<td style={{'padding-right': '10px'}}>
						<DatePicker value={this.state.dateApplied} onChange={(value) => {
							this.state.financingStrategy["date_applied"] = value
							this.props.handler("finance", this.state.itemId, null, this.state.financingStrategy)
							this.setState({dateApplied: value})
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</td>
					<td>
						<TickBoxWidget
							name={this.state.itemId}
							options={tbOptions}
							default={this.state.tbDefault}
							direction="row"
							optionSelected={(value) => {
								this.state.financingStrategy["linker"] = "0"
								this.state.financingStrategy["conduit"] = "0"
								this.state.financingStrategy["service_provider"] = "0"
								Object.entries(value.options).forEach(entry => {
									const [key, value] = entry
									switch(key) {
										case '0':
											var k = "linker"
											break
										case '1':
											k = "conduit"
											break
										case '2':
											k = "service_provider"
											break
										default:
											return
									}
									this.state.financingStrategy[k] = "1"
								})
								this.props.handler("finance", this.state.itemId, null, this.state.financingStrategy)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}}
							disabled={this.state.disabled} key={this.state.itemId} />
					</td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.financingStrategy)
					}
			}} />}
		</div>
		return(view)
	}
}

export default OrganizationFinancingTrack
